// src/features/indices/indicesSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selectedIndices: ["NDVI"],
    selectedSeason: "",
    selectedYear: "",
    startDate: "",
    endDate: "",
    chartData: {
        NDVI: { labels: [], values: [], images: [], activePoints: [] },
        NDMI: { labels: [], values: [], images: [], activePoints: [] },
        EVI: { labels: [], values: [], images: [], activePoints: [] },
        SVHI: { labels: [], values: [], images: [], activePoints: [] },
        TrueColor: { images: [] },
    },
    seasonalScores: {},
    loading: false,
    progress: 0,
};

const indicesSlice = createSlice({
    name: "indices",
    initialState,
    reducers: {
        setSelectedIndices(state, action) {
            state.selectedIndices = action.payload;
        },
        toggleIndexSelection(state, action) {
            const index = action.payload;
            if (state.selectedIndices.includes(index)) {
                if (state.selectedIndices.length > 1) {
                    state.selectedIndices = state.selectedIndices.filter((i) => i !== index);
                }
            } else {
                state.selectedIndices = [...state.selectedIndices, index];
            }
        },
        setSelectedSeason(state, action) {
            state.selectedSeason = action.payload;
        },
        setSelectedYear(state, action) {
            state.selectedYear = action.payload;
        },
        setStartDate(state, action) {
            state.startDate = action.payload;
        },
        setEndDate(state, action) {
            state.endDate = action.payload;
        },
        setChartData(state, action) {
            state.chartData = action.payload;
        },
        setSeasonalScores(state, action) {
            state.seasonalScores = action.payload;
        },
        setLoading(state, action) {
            state.loading = action.payload;
        },
        setProgress(state, action) {
            state.progress = action.payload;
        },
        resetIndicesState(state) {
            return initialState;
        },
    },
});

export const {
    setSelectedIndices,
    toggleIndexSelection,
    setSelectedSeason,
    setSelectedYear,
    setStartDate,
    setEndDate,
    setChartData,
    setSeasonalScores,
    setLoading,
    setProgress,
    resetIndicesState,
} = indicesSlice.actions;

export default indicesSlice.reducer;
